import Cookies from "js-cookie";

import { EnumUserInfo } from "@/enums/user-info.service";
import { IUserInfo } from "@/types/userInfo.type";

export const getUserIP = () => {
  const userIp = Cookies.get(EnumUserInfo.USER_IP);
  return userIp || null;
};

export const getUserEmail = () => {
  const userIp = Cookies.get(EnumUserInfo.USER_EMAIL);
  return userIp || null;
};

export const getUserInfo = () => {
  const userInfo = Cookies.get(EnumUserInfo.USER_INFO);
  return userInfo ? JSON.parse(userInfo) : null;
};

export const getUserAgreeCookies = () => {
  const userAgree = Cookies.get(EnumUserInfo.USER_AGREE_COOKIES);
  return userAgree || "false";
};

export const saveUserIP = (ip: string) => {
  Cookies.set(EnumUserInfo.USER_IP, ip, {
    sameSite: "strict",
    expires: 365,
  });
};
export const saveUserEmail = (email: string) => {
  Cookies.set(EnumUserInfo.USER_EMAIL, email, {
    sameSite: "strict",
    expires: 365,
  });
};

export const saveUserInfo = (info: IUserInfo) => {
  Cookies.set(EnumUserInfo.USER_INFO, JSON.stringify(info), {
    sameSite: "strict",
    expires: 365,
  });
};

export const saveAgreeCookies = (val: string) => {
  Cookies.set(EnumUserInfo.USER_AGREE_COOKIES, val, {
    sameSite: "strict",
    expires: 365,
  });
};

export const removeUserIP = () => {
  Cookies.remove(EnumUserInfo.USER_IP);
};
export const removeUserUserInfo = () => {
  Cookies.remove(EnumUserInfo.USER_INFO);
};
export const removeUserUserCookies = () => {
  Cookies.remove(EnumUserInfo.USER_AGREE_COOKIES);
};
export const removeUserEmail = () => {
  Cookies.remove(EnumUserInfo.USER_EMAIL);
};
